import assert from 'minimalistic-assert';
import lodash from 'lodash';
import stringify from 'json-stringify-safe';
const { isEqual: deepEqual } = lodash;
const STRINGIFY_LIMIT = 1000;
const limitedStringify = (obj, limit = STRINGIFY_LIMIT) => {
    let count = 0;
    return stringify(obj, (_, value) => {
        if (count > limit) {
            return;
        }
        if (count === limit) {
            count++;
            return '...more properties not shown';
        }
        count++;
        return value;
    });
};
const warnOnSameValueSet = ({ atom, isEqual = deepEqual, logger }) => {
    assert(atom, 'expected "atom');
    assert(typeof logger?.warn === 'function', 'expected logger with ".warn" function');
    let previousValue;
    atom.observe((value) => {
        if (value !== undefined && isEqual(value, previousValue)) {
            logger.warn(`Atom was called with the same value it currently holds: ${limitedStringify(value)}`);
        }
        previousValue = value;
    });
    return atom;
};
export default warnOnSameValueSet;
